<template>
  <div @keypress.ctrl.down="show = true" class="pr-0 embedded-page" :class="{ open: show, 'type-section': page.type == 5 }">
    <v-row no-gutters :class="{ 'px-0': true,  'py-1': true, 'ml-n5': show && page.type == 5 }" style="position: relative;">
      <v-col class="pl-0" style="max-width: 24px; width: 24px;" :class="{ 'pt-2': show && page.type == 5 }">
        <v-btn v-show="hovering || (show && page.type != 5) || focused" icon :ripple="false" @click="show = !show" small>
          <v-icon :style="show ? 'transform: rotate(90deg);' : null">keyboard_arrow_right</v-icon>
        </v-btn>
      </v-col>
      <v-hover v-slot:default="{ hover }">
        <v-col
          class="shrink"
          :class="{ 'pt-2': show && page.type == 5 }"
          :style="!show && !hovering ? 'filter: grayscale(.1); opacity: 0.4;' : null"
        >
          <page-type-select :page="page" :small="true"></page-type-select>
        </v-col>
      </v-hover>
      <v-col class="pt-1 pl-1" @click="$emit('clearDragSelection')">
        <div v-if="!userCanEdit || !editorReady" class="card-title">
          <div class="ql-editor">
            <p>{{ pageTitle.html }}</p>
          </div>
        </div>
        <content-editor
          v-else
          ref="titleEditor"
          class="card-title"
          :class="{ section: page.type == 5, open: show }"
          :disabled="!userCanEdit"
          v-model="pageTitle"
          placeholder="Untitled Card"
          allowTraversal
          :emitText="true"
          :preventTab="true"
          @keyUpFirstLine="$emit('traverseLeaveUp', $event)"
          @keyDownLastLine="
            show
              ? $refs.cardDoc.traverseInto({ event: $event, dir: 'down' })
              : $emit('traverseLeaveDown', $event)
          "
          @keyEnter="handleEnter"
          @keyShiftTab="$emit('tabBack')"
          @keyBackspaceEmpty="$emit('keyBackspaceEmpty', pageNoteLength)"
          @ctrlDown="show = true"
          @ctrlUp="show = false"
          @focus="$emit('focus')"
          @blur="$emit('blur')"
        ></content-editor>
      </v-col>
      <v-col class="shrink px-1">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-fade-transition>
              <v-btn
                :disabled="!show && !researchingHere"
                :color="researchingHere ? 'green' : 'grey lighten-1'"
                icon
                small
                class=""
                @click="researchingHere ? stopCaptureSession() : startCaptureSession({ pageId })"
                @mouseenter="on.mouseenter"
                @mouseleave="on.mouseleave"
              >
                <v-icon v-show="show || researchingHere">fiber_smart_record</v-icon>
              </v-btn>
            </v-fade-transition>
          </template>
          <span v-if="researchingHere">Stop Auto-Paste</span>
          <span v-else>Auto-Paste Research Clips Here</span>
        </v-tooltip>
      </v-col>
      <v-col class="shrink px-1">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-fade-transition>
              <v-btn
                disabled
                icon
                small
                class=""
                color="grey lighten-1"
                @click=""
                @mouseenter="on.mouseenter"
                @mouseleave="on.mouseleave"
              >
                <v-icon v-show="show">unfold_more</v-icon>
              </v-btn>
            </v-fade-transition>
          </template>
          <span>Expand All Pages</span>
        </v-tooltip>
      </v-col>
      <!-- <v-col class="shrink px-1">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-fade-transition>
              <v-btn
                :disabled="!show"
                icon
                small
                class=""
                color="grey lighten-1"
                @click="setSelectedPageId({ page: pageId, addCrumb: true })"
                @mouseenter="on.mouseenter"
                @mouseleave="on.mouseleave"
              >
                <v-icon v-show="show">input</v-icon>
              </v-btn>
            </v-fade-transition>
          </template>
          <span>Go to Page</span>
        </v-tooltip>
      </v-col> -->
      <v-col class="shrink px-1">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-fade-transition>
              <v-btn
                :disabled="!show && !page.important && !hovering"
                icon
                small
                class=""
                :color="page.important ? 'primary' : 'grey lighten-1'"
                @click="updatePageImportant({ pageId: page.id, value: !page.important })"
                @mouseenter="on.mouseenter"
                @mouseleave="on.mouseleave"
              >
                <v-icon v-if="!page.important" v-show="show || hovering">bookmark_border</v-icon>
                <v-icon v-if="page.important">bookmark</v-icon>
              </v-btn>
            </v-fade-transition>
          </template>
          <span>Mark Important</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <div class="px-2">
      <v-divider v-if="show"></v-divider>
    </div>
    <context-doc
      class="pl-5"
      v-if="show"
      style=""
      ref="cardDoc"
      :pageId="pageId"
      :allowQuoteAttr="false"
      :nested="true"
      :selectedNoteBlocks="selectedNoteBlocks"
      @clearDragSelection="$emit('clearDragSelection')"
      @updateSelectedNotes="$emit('updateSelectedNotes', $event)"
      @updateSelectedNotesPage="$emit('updateSelectedNotesPage', $event)"
      @traverseLeaveUp="$refs.titleEditor.setCaret($event)"
      @traverseLeaveDown="$emit('traverseLeaveDown', $event)"
    >
    </context-doc>
    <template v-if="!pageNoteLength && show && templates[page.type].length">
      <div class="px-12 pb-3" style="opacity: 0.7">
        <div class="pa-4 grey lighten-5">
          <div class="caption">Templates</div>
          <v-list color="transparent">
            <v-list-item
              v-for="template in templates[page.type]"
              @click="addTemplate(template)"
              :key="template.name"
            >
              <v-list-item-avatar><v-icon>list</v-icon></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ template.name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ContentEditor from '@/components/ContentEditor';
import PageTypeSelect from '@/components/ContextDoc/PageTypeIcon/PageTypeSelect';

import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
export default {
  components: {
    ContextDoc: () => import('@/components/ContextDoc'),
    ContentEditor,
    PageTypeSelect
  },
  props: [
    'pageId',
    'userCanEdit',
    'hovering',
    'showDoc',
    'selectedNoteBlocks',
    'no-children',
    'editorReady',
    'parentPageId',
    'parentNoteId',
    'focused'
  ],
  data() {
    return {
      // show: false
      templates: {
        0: [
          //note templates
        ],
        1: [
          //  question templates
          {
            name: '"Should I do this" Decisions',
            cards: [
              'What are you trying to achieve?',
              'Will this help you achieve it?',
              `What if it doesn't go well?`,
              `What if it goes great?`,
              'What do experts say?',
              'Who can you talk to for advice?'
            ]
          }
        ],
        2: [
          //  concern templates
        ],
        3: [
          //  idea templates
          {
            name: 'Feature Idea',
            cards: [
              'Is it relevant to our mission?',
              'What problem are we trying to solve?',
              `How else can we solve the problem?`,
              `Will solving the problem have an impact?`,
              'Will people hate it?'
            ]
          }
        ],
        4: [
          //  claim templates
        ],
        5: [
          //  group templates
        ],
        6: [
          //  task templates
        ]
      }
    };
  },
  computed: {
    ...mapState('pages', ['pages']),
    ...mapGetters('auth', ['researchSession']),
    page() {
      return this.pages[this.pageId];
    },
    show: {
      get() {
        return this.showDoc;
      },
      set(v) {
        this.$emit('setShow', v);
      }
    },
    pageTitle: {
      get() {
        return { html: this.page.title };
      },
      set(v) {
        console.log(v);
        this.updatePageTitle({ pageId: this.pageId, title: v });
      }
    },
    pageNoteLength() {
      return Object.values(this.page.pageNotes).filter(
        n => !n.toDelete && (n.type != 'note' || n.content.html.length > 1)
      ).length;
    },
    researchingHere() {
      return (
        this.researchSession &&
        this.researchSession.researching &&
        this.researchSession.pageId == this.pageId
      );
    }
  },
  methods: {
    ...mapActions('pages', ['updatePageTitle', 'updatePageType', 'updatePageImportant']),
    ...mapActions('auth', ['startCaptureSession', 'stopCaptureSession']),
    ...mapMutations('views/context', ['setSelectedPageId']),
    traverseIn({ prevLeft, direction, event }) {
      console.log(prevLeft, direction, event);
      const pLeft = prevLeft || (event && event.bounds) ? event.bounds.left : 0;
      if (direction == 'down' || !this.show) {
        console.log('direction down', direction);
        this.$refs.titleEditor.setCaret({
          prevLeft: pLeft,
          direction
        });
      } else {
        this.$refs.cardDoc.traverseInto({ event, direction });
      }
    },
    handleEnter(empty) {
      if (this.show) {
        this.$refs.cardDoc.addNewLine({ order: 0 });
      } else {
        if (empty) {
          console.log(this.page.pageNotes);
          this.$emit('keyBackspaceEmpty', this.pageNoteLength);
        } else {
          this.$emit('addNewLineBelow', { pageType: this.page.type });
        }
      }
    },
    addTemplate(template) {
      this.$refs.cardDoc.addNewLine({ order: 0 });
      template.cards.forEach((t, i) => {
        this.$refs.cardDoc.addCardNote({
          html: t,
          order: i,
          pageId: this.page.id,
          cardId: false,
          type: 'card',
          pageType: 1
        });
      });
    }
  }
};
</script>

<style>
.card-title .ql-editor p {
  font-size: 16px !important;
  font-weight: 500;
}

.section.card-title.open .ql-editor p {
  font-size: 26px !important;
  font-weight: 500;
}

.embedded-page .embedded-page .section.card-title.open .ql-editor p {
  font-size: 20px !important;
  font-weight: 500;
}

.embedded-page {
  border: 1px solid rgb(244, 244, 244);
  border-radius: 2px;
  transition: 0.3s ease all;
}

.embedded-page.open {
  border: 1px solid rgb(230, 230, 230);
}

.embedded-page.type-section.open {
  border: 1px solid rgba(230, 230, 230, 0);
}

.embedded-page .noteBlock .ql-editor h1 {
  font-size: 1.2em !important;
}
</style>
